import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	ims: boolean | null;
	isLinked: boolean | null;
	mme: boolean | null;
	searchField: string;
	status: string | null;
	crowdCellId: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	ims: null,
	isLinked: null,
	mme: null,
	searchValue: '',
	searchField: '',
	sortDirection: false,
	sortFieldName: null,
	status: null,
	crowdCellId: null,
};

const crowdCells = createSlice({
	name: 'crowdCells',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setSearchField: (state, action: PayloadAction<{ searchField: string }>) => {
			state.searchField = action.payload.searchField;
			state.page = initialState.page;
		},
		setMme: (state, action: PayloadAction<{ mme: boolean | null }>) => {
			state.mme = action.payload.mme;
			state.page = initialState.page;
		},
		setIms: (state, action: PayloadAction<{ ims: boolean | null }>) => {
			state.ims = action.payload.ims;
			state.page = initialState.page;
		},
		setStatus: (state, action: PayloadAction<{ status: string | null }>) => {
			state.status = action.payload.status;
			state.page = initialState.page;
		},
		setCrowdCellId: (state, action: PayloadAction<{ crowdCellId: string }>) => {
			state.crowdCellId = action.payload.crowdCellId;
			state.page = initialState.page;
		},
		setIsLinked: (state, action: PayloadAction<{ isLinked: boolean | null }>) => {
			state.isLinked = action.payload.isLinked;
			state.page = initialState.page;
		},
		resetCrowdCellsTable: () => initialState,
	},
});

export const {
	resetCrowdCellsTable,
	setIms,
	setIsLinked,
	setMme,
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
	setStatus,
	setCrowdCellId,
	setSearchField,
} = crowdCells.actions;

export default crowdCells.reducer;
